<template>
    <conversation-list
        :key="conversationListKey"
        v-if="isSendListSelected"
        v-loading="isBusy"
        ref="list"
        :index-url="indexUrl"
        :margin="8"
        @delete="onDelete"
        @edit="onEdit"
        @open-chat="onOpenChat"
        @restore="onRestore"
        @move="onMove"
        :note="note"
        :read-only-notes="readOnlyNotes"
        :store-note-url="getStoreNoteUrl"
        :send-list-id="getSendListId"
        :can-set-read-only-note="canSetReadOnlyNote"
    >
    </conversation-list>
</template>

<script>
  import ConversationList from "../../../components/send-list/conversations/index";
  import eventBus from "../../../event-bus";

  export default {
    components: {
      'conversation-list': ConversationList,
    },

    props: {
      sendList: null,
    },

    data() {
      return {
        isBusy: false,
        conversationListKey: moment().format('x'),
      };
    },

    computed: {
      /**
       * @return {String|null}
       */
      indexUrl() {
        return _.get(this.sendList, 'conversationListUrl', null);
      },

      /**
       * @return {Boolean}
       */
      isSendListSelected() {
        return Boolean(this.indexUrl);
      },

      /**
       * @return {Object}
       */
      note() {
        return _.get(this.sendList, 'note');
      },

      /**
       * @return {Object}
       */
      readOnlyNotes() {
        return _.get(this.sendList, 'read_only_notes');
      },

      /**
       * @return {String}
       */
      getStoreNoteUrl() {
        return _.get(this.sendList, 'storeNoteUrl');
      },

      /**
       * @return {Number}
       */
      getSendListId() {
        return _.get(this.sendList, 'id');
      },

      /**
       * @return {Boolean}
       */
      canSetReadOnlyNote() {
        return _.get(this.sendList, 'canSetReadOnly');
      },
    },

    watch: {
      sendList: {
        handler: function (val) {
          this.conversationListKey = moment().format('x');
        },
        immediate: true,
      }
    },

    methods: {
      /**
       * @param {Object} item
       */
      onDelete(item) {
        this.$confirm('Do you confirm deleting?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        })
          .then(() => this.deleteItem(item))
          .catch(() => {});
      },

      /**
       * @param {Object} item
       */
      onEdit(item) {
        eventBus.$emit('show-send-list-conversation-modal-form', {
          title: 'EDIT GROUP ITEM',
          url: _.get(item, 'edit_url'),
          model: {},
        })
      },

      /**
       * @param {object} payload
       */
      onOpenChat(payload) {
        eventBus.$emit('show-chat-dialog', payload);
      },

      /**
       * @param {Object} item
       */
      onRestore(item) {
        this.isBusy = true;
        const url = _.get(item, 'restoreUrl');

        if (url) {
          axios.post(url)
            .then(({data: {message, model}}) => {
              this.$message.success(message);
              this.$refs.list.editItem(model);
            })
            .finally(() => this.isBusy = false);
        }
      },

      /**
       * @param {String} url
       * @emits show-move-to-group-dialog
       */
      onMove(url) {
        eventBus.$emit('show-move-to-group-dialog', {
          url: url,
          brand_id: _.get(this.sendList, 'brand_id'),
        });
      },

      /**
       * @param {Object} item
       */
      deleteItem(item) {
        this.isBusy = true;
        const url = _.get(item, 'destroy_url');
        if (url) {
          axios.delete(url)
            .then(({data: {message}}) => {
              this.$message.success(message);
              this.$refs.list.removeItemById(_.get(item, 'id'));
            })
            .finally(() => this.isBusy = false);
        }
      },

      /**
       * @return {undefined}
       */
      onSendListItemsUpdated() {
        this.$refs.list.refreshList();
      },
    },

    created() {
      eventBus.$on('send-list-items-updated', this.onSendListItemsUpdated);
    },

    beforeDestroy() {
      eventBus.$off('send-list-items-updated', this.onSendListItemsUpdated);
    },
  }
</script>

